<template>
	<div class="partTag">
		<!--弹出框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
			<div class="title">
				<dl>
					<dt class="fl"><span class="checktip">* </span>结构名称：</dt>
					<dd class="cf">
						<input type="text" class="input mid focusing" v-model="dialogData.name">
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()" :loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<!--导航条-->
		<navZcy v-bind:num="'3-4'" style="min-width: 1300px;"></navZcy>
		<div class="line"></div>
		<div class="main" style="width: 1000px;">
			<!--页面标题-->
			<div class="top cf">
				<div class="topL fl"><span>零件结构</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="line"></div>
			<div class="dataTag">
				<!--操作按钮-->
				<div class="handle">
					<div class="fl">
						<img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
						<span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
					</div>
					<div class="handleBtn fr">
						<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
						<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
					</div>
				</div>
				<!--列表内容-->
				<div class="tableData" style="text-align: center;">
					<el-table 
						ref="multipleTable"
						:data="tableData" 
						border 
						@selection-change="handleSelectionChange" 
						style="width: 100%;border-bottom: 1px solid #ddd;">
						<el-table-column type="selection" width="200px">
						</el-table-column>
						<el-table-column type="index" label="序号" width="200px">
						</el-table-column>
						<el-table-column prop="name" label="零件类别名称" width="250px">
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
								<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import treeView from './treeView'
import '../assets/css/style.css'
import navZcy from './nav'
export default {
	data() {
		return {
			loading: false,
			dialogTitle: "",    //弹出框标题
			dialogVisible: false,//弹出框是否显示
			dialogData: {},     //弹出框参数
			tableData: [],		//列表内容数组
			multipleSelection: []//列表复选框被选中值
		}
	},
	methods: {
		//获取零件类别
		queryComponent(){
			let url = "/lightApi/structure/inquiryStructure/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': {},'Fn': this.queryComponentFn,'vue':this})
		},
		queryComponentFn(data) {
			if(data.msg=='ok'){
				this.tableData = data.data.items
			}else{
				this.tableData = []
			}
		},
		//页面刷新
		refresh() {
			location.reload();
		},
		//弹出框关闭
		handleClose: function(done) {
			done()
		},
		//添加零件结构
		handleAdd: function() {		
			this.loading = false
			this.dialogTitle = "添加零件结构";
			this.dialogData = {
				name: ''
			}
			this.dialogVisible = true;
			setTimeout(function(){
				$('.focusing').focus()
			},100)	
		},
		//编辑零件结构
		handleEdit: function(index, row) {
			this.loading = false
			this.dialogTitle = "编辑零件结构";
			this.dialogData = {
				id: row.id,
				name: row.name
			}
			this.dialogVisible = true;
			setTimeout(function(){
				$('.focusing').focus()
			},100)	
		},
		//确定添加/编辑
		handleConfirm: function(){
			this.loading = true
			if(this.dialogData.name.trim()){
				let url
				if(this.dialogData.id){
					url = "/lightApi/structure/updateStructure/"+sessionStorage.getItem('sessionId')
				}else{
					url = "/lightApi/structure/createStructure/"+sessionStorage.getItem('sessionId')
				}
				this.$store.dispatch('handlePost',{'url': url, 'data': this.dialogData,'Fn': this.handleConfirmFn,'vue':this})
			}else{
				this.loading = false
				if(!this.dialogData.name.trim()){
					this.dialogData.name = ""
					this.$message({
						type: 'error',
						message: '请输入零件类别名称'
					});
				}
			}
		},
		handleConfirmFn(data) {
			if(data.msg=="ok"){
				this.dialogVisible = false
				this.queryComponent()
			}else{
				this.loading = false
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
		//列表复选框被选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				if(val[i].id!=1){
					this.multipleSelection.push(val[i].id)
				}				
			}
		},
		//删除零件类别
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection					
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该零件标签, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {			
					let url = "/lightApi/structure/deleteStructure/"+sessionStorage.getItem('sessionId')+"/"+id  
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}			
		},
		handleDeleteFn(data) {
			if(data.msg=="ok"){							
				this.queryComponent()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});
				this.queryComponent()
			}
		}
	},
	mounted() {
		this.queryComponent()
	},
	components: {
		navZcy,
		treeView
	}
}
</script>

<style scoped>
	.treeOuter{
		background: #267cb7;
		width: 100%;
		padding-right: 20px;
	}
	.treeTitle{
		display: block;
		color: goldenrod;
		margin-left: 10px;
		padding-top: 20px;
	}
	dl dt{
		width: 80px;
	}
	dl{
		margin: 20px 0;
		line-height: 33px;
	}
</style>


// WEBPACK FOOTER //
// src/components/partTag.vue